/* SS - Trustpilot + klipp: karusell med midten i fokus (variant A), uendelig loop. 16.09.2026.
   Scroll-snap gjør selve sveipen. Kloner av alle klippene legges foran og bak originalene (tre sett), så det alltid er
   et klipp på hver side av det aktive. Når sveipen har roet seg og vi står i et klone-sett, flyttes scrollLeft ett
   sett-bredde uten animasjon til samme klipp i midt-settet - usynlig for brukeren.
   Video: lydløs, loop, ingen innebygde kontroller. Klippet i fokus forhåndslastes når seksjonen nærmer seg (600px),
   spiller av seg selv når seksjonen er synlig, pauses når den forsvinner. Trykk = pause/fortsett. Kjører også ved shopify:section:load. */
(function () {
  function init(root) {
    if (root.__ssCar) return; root.__ssCar = true;
    var track = root.querySelector('.ss-proof__track');
    var originals = track ? [].slice.call(track.querySelectorAll('.ss-proof__clip')) : [];
    var prev = root.querySelector('.ss-proof__arrow--prev'), next = root.querySelector('.ss-proof__arrow--next');
    var dotsWrap = root.querySelector('.ss-proof__dots');
    if (!track || !originals.length) return;
    var n = originals.length;
    var inView = false, near = false;

    function clone(el) {
      var c = el.cloneNode(true); c.classList.add('is-clone'); c.setAttribute('aria-hidden', 'true');
      var v = c.querySelector('video'); if (v) v.parentNode.removeChild(v);
      c.classList.remove('ss-proof__clip--has-video', 'is-active', 'is-playing', 'has-started');
      for (var i = c.attributes.length - 1; i >= 0; i--) { var a = c.attributes[i].name; if (a.indexOf('data-shopify') === 0) c.removeAttribute(a); }
      return c;
    }
    var items, dots = [], active = -1, settleTimer;
    if (n < 2) {
      root.classList.add('ss-proof__car--single'); items = originals; originals[0].classList.add('is-active'); active = 0;
    } else {
      var before = document.createDocumentFragment(), after = document.createDocumentFragment();
      originals.forEach(function (el) { before.appendChild(clone(el)); after.appendChild(clone(el)); });
      track.insertBefore(before, track.firstChild); track.appendChild(after);
      items = [].slice.call(track.querySelectorAll('.ss-proof__clip'));   /* 3n stk; originalene er n..2n-1 */
      dots = originals.map(function (c, i) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'ss-proof__dot';
        b.setAttribute('aria-label', (i + 1) + ' / ' + n);
        b.addEventListener('click', function () { go(n + i); });
        dotsWrap.appendChild(b); return b;
      });
    }

    function video(el) { return el ? el.querySelector('video') : null; }
    function setWidth() { return items[n].offsetLeft - items[0].offsetLeft; }
    function isOriginal(i) { return n < 2 || (i >= n && i < 2 * n); }

    function update() {
      var c = track.scrollLeft + track.clientWidth / 2, best = 0, bestD = 1e9;
      for (var i = 0; i < items.length; i++) {
        var el = items[i], mid = el.offsetLeft + el.offsetWidth / 2, d = Math.abs(mid - c), t = Math.min(1, d / el.offsetWidth);
        el.style.transform = 'scale(' + (1 - 0.2 * t).toFixed(4) + ')';
        el.style.opacity = (1 - 0.45 * t).toFixed(3);
        if (d < bestD) { bestD = d; best = i; }
      }
      if (best !== active) {
        if (active >= 0) { items[active].classList.remove('is-active'); var pv = video(items[active]); if (pv && !pv.paused) pv.pause(); }
        active = best; items[active].classList.add('is-active');
        for (var k = 0; k < dots.length; k++) dots[k].classList.toggle('is-active', k === (active % n));
      }
    }
    function jump(left) { track.style.scrollBehavior = 'auto'; track.scrollLeft = left; track.style.scrollBehavior = ''; }
    function go(i, instant) {
      i = Math.max(0, Math.min(items.length - 1, i));
      var el = items[i], left = el.offsetLeft + el.offsetWidth / 2 - track.clientWidth / 2;
      if (instant || !('scrollBehavior' in document.documentElement.style)) jump(left);
      else track.scrollTo({ left: left, behavior: 'smooth' });
    }
    /* når sveipen har roet seg: står vi i et klone-sett, hopp usynlig til midt-settet; så forhåndslast/spill klippet i fokus */
    function settle() {
      if (n >= 2) {
        if (active < n) jump(track.scrollLeft + setWidth());
        else if (active >= 2 * n) jump(track.scrollLeft - setWidth());
      }
      update(); preloadActive(); autoplay();
    }
    function preloadActive() {
      var v = video(items[active]);
      if (near && v && isOriginal(active) && v.preload !== 'auto') { v.preload = 'auto'; try { v.load(); } catch (e) {} }
    }
    function autoplay() {
      var el = items[active], v = video(el);
      pauseAll(root, v);
      if (!inView || !v || !isOriginal(active) || el.__userPaused) return;
      resumeAt(el, v); var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
    }

    if (prev && next && n >= 2) {
      prev.addEventListener('click', function () { go(active - 1); });
      next.addEventListener('click', function () { go(active + 1); });
    }
    track.addEventListener('scroll', function () {   /* ikke rAF: fyrer ikke i skjulte tabs */
      update();
      clearTimeout(settleTimer); settleTimer = setTimeout(settle, 140);
    }, { passive: true });
    if ('onscrollend' in window) track.addEventListener('scrollend', function () { clearTimeout(settleTimer); settle(); });
    var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { go(active, true); update(); }, 120); });

    items.forEach(function (el, i) {
      el.addEventListener('click', function (e) {
        /* 22.09.2026: «Vis produkter»-pillen og produktboksen ligger inne i klippet - la dem passere,
           ellers ville klikket her pauset/startet videoen i samme slengen (assets/ss-shop.js). */
        if (e.target.closest('[data-ss-shop],[data-ss-shop-box]')) return;
        if (i !== active) { e.preventDefault(); go(i); return; }
        var v = video(el); if (!v) return;
        if (v.paused) { el.__userPaused = false; pauseAll(root, v); resumeAt(el, v); var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
        else { el.__userPaused = true; v.pause(); }
      });
      var v = video(el);
      if (v) {
        v.muted = true; v.loop = true; v.controls = false; v.setAttribute('playsinline', '');
        /* 'playing' (ikke 'play'): først når et bilde faktisk vises - ellers blinker det sort mellom plakat og første bilde */
        v.addEventListener('playing', function () { el.classList.add('is-playing'); el.classList.add('has-started'); });
        v.addEventListener('pause', function () { el.classList.remove('is-playing'); snapshot(el, v); });
        /* iOS kan tømme et pauset klipp som har vært lenge ute av syne; da vises plakaten igjen til det spiller, og vi fortsetter der det slapp */
        v.addEventListener('timeupdate', function () { if (v.currentTime > 0.5) el.__t = v.currentTime; });
        v.addEventListener('emptied', function () { el.classList.remove('has-started', 'is-playing'); });
      }
    });

    /* seksjonen nærmer seg (600px): last klippet i fokus. Synlig (>=50 %): spill. Ute av syne: pause. */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { near = es[0].isIntersecting; if (near) preloadActive(); }, { rootMargin: '600px 0px' }).observe(root);
      new IntersectionObserver(function (es) {
        inView = es[0].isIntersecting && es[0].intersectionRatio >= 0.5;
        if (inView) autoplay(); else pauseAll(root, null);
      }, { threshold: [0, 0.5, 1] }).observe(root);
    } else { near = true; inView = true; }

    /* start i fokus på det første klippet som har video (så det spiller med en gang), ellers det midterste */
    var startIdx = Math.floor(n / 2);
    for (var s = 0; s < n; s++) { if (video(originals[s])) { startIdx = s; break; } }
    if (n >= 2) go(n + startIdx, true);
    update(); preloadActive(); autoplay();
  }
  /* 18.09.2026 (Kristoffer): ved pause tegnes siste bilde inn i plakaten - baade klippets egen og klonenes (looping-kopiene har ingen video).
     Foer: sveip forbi siste klipp landet paa klonen av det foerste, som viste det gamle plakatbildet, saa hoppet vi til originalen med
     det fryste bildet - opplevdes hakkete. Naa viser klone og original det samme. Dekker ogsaa iOS som toemmer pausede klipp (plakaten
     som da vises er siste bilde, ikke det gamle). Krever crossorigin=anonymous paa <video> (snippets/ss-proof-video.liquid). */
  function snapshot(el, v) {
    if (!v || v.readyState < 2 || !v.videoWidth || v.currentTime < 0.2) return;
    try {
      var c = snapshot.c || (snapshot.c = document.createElement('canvas'));
      var w = 360, h = Math.round(w * v.videoHeight / v.videoWidth); c.width = w; c.height = h;
      c.getContext('2d').drawImage(v, 0, 0, w, h);
      var url = c.toDataURL('image/jpeg', 0.82);
      var root = el.closest('[data-ss-car]'); var all = root ? [].slice.call(root.querySelectorAll('.ss-proof__clip')) : [el];
      var n = root ? root.querySelectorAll('.ss-proof__clip:not(.is-clone)').length : 1; var i = all.indexOf(el);
      [el, all[i - n], all[i + n]].forEach(function (c2) {
        if (!c2) return; var img = c2.querySelector('img.ss-proof__poster'); if (!img) return;
        img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = url;
      });
    } catch (e) { /* tainted canvas e.l. - da staar plakaten som foer */ }
  }
  function resumeAt(el, v) {
    /* nettleseren har nullstilt klippet (iOS): hopp tilbake dit brukeren var */
    if (!el.__t || v.currentTime > 0.2) return;
    var t = el.__t, seek = function () { try { v.currentTime = t; } catch (e) {} };
    if (v.readyState >= 1) seek(); else v.addEventListener('loadedmetadata', seek, { once: true });
  }
  function pauseAll(root, except) {
    var all = root.querySelectorAll('video');
    for (var j = 0; j < all.length; j++) if (all[j] !== except && !all[j].paused) all[j].pause();
  }
  function initAll(scope) { var list = (scope || document).querySelectorAll('[data-ss-car]'); for (var i = 0; i < list.length; i++) init(list[i]); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); }); else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
